import {
  components as selectComponents,
  ClearIndicatorProps,
} from 'react-select'

import { Select } from '@/Atomic/Molecules/Inputs/Select'

interface FilterOption {
  label: string
  value: string
}

interface FilterSelectFieldProps {
  label: string
  keyPrefix: string
  options: FilterOption[]
  value: string | null
  placeholder: string
  isDisabled?: boolean
  onChange: (value: string | null) => void
  extraKey?: string
}

const clearableComponents = (onClear: () => void) => ({
  IndicatorSeparator: () => null,
  ClearIndicator: (props: ClearIndicatorProps) => (
    <selectComponents.ClearIndicator
      {...props}
      innerProps={{
        ...props.innerProps,
        onMouseDown: (e) => {
          e.stopPropagation()
          e.preventDefault()
          onClear()
          props.innerProps?.onMouseDown?.(e)
        },
      }}
    />
  ),
})

export const FilterSelectField = ({
  label,
  keyPrefix,
  options,
  value,
  placeholder,
  isDisabled,
  onChange,
  extraKey,
}: FilterSelectFieldProps) => (
  <div className="time-tracking-filter-section">
    <label className="form-label">{label}</label>
    <Select
      key={`${keyPrefix}-${value || 'empty'}-${options.length}${extraKey ? `-${extraKey}` : ''}`}
      name=""
      options={options}
      defaultValue={value}
      onChange={(v) => onChange(typeof v === 'string' ? v : null)}
      placeholder={placeholder}
      isDisabled={isDisabled}
      components={clearableComponents(() => onChange(null))}
    />
  </div>
)
